import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    DeleteAudienceForEntityList as DeleteAudienceForEntityListMutation,
    DeleteAudienceForEntityListVariables as DeleteAudienceForEntityListVariables,
    AudienceDeleteInput,
} from 'nutshell-graphql-types';

import {DEFAULT_GET_AUDIENCE_VARIABLES} from '../../entity-list-sidebar/consts';

import DELETE_AUDIENCE_FOR_ENTITY_LIST from '../mutations/delete-audience-for-entity-list.graphql';
import GET_AUDIENCES from '../queries/get-audiences.graphql';

export const useDeleteAudienceForEntityList = (
    searchNameQuery?: string | null
): {
    deleteAudienceForEntityList: (arg1: AudienceDeleteInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [deleteAudienceForEntityList, {loading, error}] = useMutation<
        DeleteAudienceForEntityListMutation,
        DeleteAudienceForEntityListVariables
    >(DELETE_AUDIENCE_FOR_ENTITY_LIST);

    return {
        deleteAudienceForEntityList: (input: AudienceDeleteInput) =>
            deleteAudienceForEntityList({
                variables: {input},
                update: (proxy, mutationResults) => {
                    const cacheResult = proxy.readQuery({
                        query: GET_AUDIENCES,
                        variables: {
                            ...DEFAULT_GET_AUDIENCE_VARIABLES,
                            search: searchNameQuery,
                        },
                    });

                    const deletedAudience =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.audienceDelete &&
                        mutationResults.data.audienceDelete.audience;

                    if (!deletedAudience) return;

                    if (cacheResult) {
                        const data = {
                            audiences: {
                                // @ts-expect-error
                                ...cacheResult.audiences,
                                // @ts-expect-error
                                edges: cacheResult.audiences.edges.filter(
                                    // @ts-expect-error
                                    (edge) => edge.node.id !== deletedAudience.id
                                ),
                            },
                        } as const;

                        proxy.writeQuery({
                            variables: {
                                ...DEFAULT_GET_AUDIENCE_VARIABLES,
                                search: searchNameQuery,
                            },
                            query: GET_AUDIENCES,
                            data: data,
                        });
                    }
                },
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
